<div class="d-flex" rt="user-thumbnail">
  <div
    [style.backgroundImage]="'url(' + imageUrl + ')'"
    class="d-inline-flex align-items-start rounded-circle bg-white thumbnail mr-2"
    rt="user-thumbnail-image"
  >
    <i *ngIf="imageUrl.length === 0" class="icon-user text-grey m-auto"></i>
  </div>
  <div class="d-inline-flex align-self-center d-inline-flex section-header" rt="user-thumbnail-name">
    {{ userName }}
  </div>
</div>
